import { Grid, TextField } from '@mui/material';
import { GridRowsProp, useGridApiRef } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IButton from '../../../components/button/i-button.component';
import IForm from '../../../components/i-form/i-form.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { COSTING_TYPE_SELECT_ITEMS, UOM_SELECT_ITEMS, COST_OWNER_SELECT_ITEMS, EMPTY_STRING } from '../../common/constants';
import { isEmpty, isNotEmpty, isNotEmptyArray, isNotNull, isZero, isNullData, formatTo2Decimal, formatTo1Decimal, formatToNumber } from '../../common/util.services';
import { getCurrencyRate } from '../../currency/currency.services';
import { getCostingDataById, saveCosting } from '../costing.services';
import CostingDetailComponent from '../detail/costing-detail.component';
import './costing-form.component.scss';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import { getParameter } from '../../amazon/amazon.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import OtherCostComponent from '../detail/other-cost.component';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import CalculateIcon from '@mui/icons-material/Calculate';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import InfoIcon from '@mui/icons-material/Info';

const CostingForm = () => {
  const [title, setTitle] = useState<string>('');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rowId = params.rowId;
  const rows: GridRowsProp = [];
  const [detailRows, setDetailRows] = useState(rows);
  const [costingData, setCostingData] = useState<any>({costingDate: dayjs()});
  const [openOthCost, setOpenOthCost] = useState(false);
  const [otherCost, setOtherCost] = useState<any>([]);
  const [inputCodeList, setInputCodeList] = useState<any>(['NA']);
  const apiRef = useGridApiRef();
  const [inputCost, setInputCost] = useState(0);
  const [costingType, setCostingType] = useState(EMPTY_STRING);
  const [loader, setLoader] = useState(true);
  const [contingency, setContingency] = useState(0);
  const [financeCost, setFinanceCost] = useState(0);
  const [commission, setCommission] = useState(0);
  const [length, setLength] = useState<any>(0);
  const [breadth, setBreadth] = useState<any>(0);
  const [height, setHeight] = useState<any>(0);
  const [cbm, setCBM] = useState<any>('NA');
  const [qtyPerCarton, setQtyPerCarton] = useState<any>(0);
  const [usdRate, setUSDRate] = useState(0);
  const [price, setPrice] = useState(0);
  const [eurRate, setEURRate] = useState(0);
  const [totalUSD, setTotalUSD] = useState(0);
  const [totalEUR, setTotalEUR] = useState(0);
  const [rates, setRates] = useState<any>(null);
  const [rateText, setRateText] = useState('');
  const [isBale, setIsBale] = useState(false);
  const [overhead, setOverhead] = useState(0);
  const {state} = useLocation();
  const {enquiryCode, customer, product, description, moq, uom, enqProductId, setQty, fabricGsm, fabricWidth, enquiryDate} = state;

  useEffect(() => {
    fetchCurrencyRate();
    fetchCostingData();
    fetchOverhead();
  }, []);

  const fetchOverhead = () => {
    getParameter(appContext,
      (response: any) => {
        setOverhead(response.data.overhead);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
      });
  }

  const fetchCostingData = () => {
    if (isNotNull(rowId)) {
      getCostingDataById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Costing Data');
          if(0 === response.data.pack) {
            response.data.pack = 'NA';
          }
          setCostingData(response.data);
          setOtherCost(response.data.otherCost);
          setCostingType(response.data.type);
          setPrice(response.data.totalCost);
          setContingency(response.data.contingencyPercentage);
          setFinanceCost(response.data.financeCost);
          setCommission(response.data.commissionPercentage);
          setLength(response.data.length);
          setBreadth(response.data.breadth);
          setHeight(response.data.height);
          setQtyPerCarton(response.data.qtyPerCarton);
          response.data.weight = Number(response.data.gsm * response.data.width * 0.0254 / 1000).toFixed(3);
          response.data.costingDate = dayjs(response.data.costingDate);
          response.data.enquiryDate = dayjs(response.data.enquiryDate);
          setIsBale(1 === response.data.isBale);
          setUSDRate(response.data.usdRate);
          setEURRate(response.data.eurRate);
          setDetailRows(response.data.detail);
          setRateText('Costing');
          appContext.setShowLoader(false);
          setLoader(false);
          //setInterval(onCalculate, 1000);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
          appContext.setErrorMessage(error.message);
        });
    } else if (isNotNull(enquiryCode)) {
          setTitle('Add Costing Data');
          costingData.enquiryCode = enquiryCode;
          costingData.customer = customer;
          costingData.product = product;
          costingData.description = description;
          costingData.moq = moq;
          costingData.uom = uom;
          costingData.otherCostVal = 0;
          costingData.contingencyPercentage = 2;
          setContingency(2);
          costingData.financeCost = 2;
          setFinanceCost(2);
          costingData.enqProductId = enqProductId;
          costingData.length = length;
          costingData.breadth = breadth;
          costingData.height = height;
          costingData.qtyPerCarton = qtyPerCarton;
          costingData.pack = 0 === setQty ? 'NA' : setQty;
          costingData.gsm = isEmpty(fabricGsm) || 'NA' === fabricGsm ? 0 : fabricGsm;
          costingData.width = isEmpty(fabricWidth) || 'NA' === fabricWidth ? 0 : fabricWidth;
          costingData.weight = Number(costingData.gsm * costingData.width * 0.0254 / 1000).toFixed(3);
          costingData.enquiryDate = dayjs(enquiryDate);

          setRateText("Latest");
          appContext.setShowLoader(false);
          setLoader(false);
    } else {
      setLoader(false);
    }
  }

  const fetchCurrencyRate = () => {
    getCurrencyRate(appContext,
      (response: any) => {
        setRates(response.data);
        setUSDRate(response.data.usdRate);
        setEURRate(response.data.eurRate);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
      });
  }

  useEffect(() => {
    if(!isNullData(length) && !isNullData(breadth) && !isNullData(height)) {
      setCBM((+length * +breadth * +height * 16.387 / (1000000 * qtyPerCarton * costingData.pack)).toFixed(6));
    } else {
      setCBM('NA');
    }
  }, [length, breadth, height, qtyPerCarton]);

  useEffect(() => {
    setUSDRate(null === usdRate ? rates.usdRate : usdRate);
    setEURRate(null === eurRate ? rates.eurRate : eurRate);
    setTotalUSD(parseFloat((price/usdRate).toFixed(2)));
    setTotalEUR(parseFloat((price/eurRate).toFixed(2)));
  }, [inputCost, contingency, financeCost, price, commission, usdRate, eurRate]);

  const validateForm = () => {
    if(!validateDependencies() || !checkOutputSplit()) {
      return false;
    }

    let valid = true;
    detailRows.forEach(row => {
      if (isZero(row.dependency) || isZero(row.unitCost) || '%' === row.processLossPercentage || 
          isZero(row.consumption) || isZero(row.outputDesc) || isZero(row.outputUom) || isZero(row.output)) {
        valid = false;
        appContext.setDialogMessage('Some of the values are empty or 0.');
      }
    })

    return valid;
  }

  const validateDetails = () => {
    if(detailRows.length <= 0) {
      appContext.setDialogMessage('Add costing details.');
      return false;
    }

    return true;
  }

  const validateDates = (data: any) => {
    let today = dayjs(dayjs().format('YYYY-MM-DD'));
    let cosDate = dayjs(dayjs(data.costingDate).format('YYYY-MM-DD'));
    let enqDate = dayjs(dayjs(data.enquiryDate).format('YYYY-MM-DD'));
    let ordDate = dayjs(dayjs(data.orderDate).format('YYYY-MM-DD'));
    if(cosDate.isAfter(today)) {
      appContext.setDialogMessage('Future costing date is not allowed.');
      return false;
    } else if(cosDate.isBefore(enqDate)) {
      appContext.setDialogMessage('Costing date is before enquiry date.');
      return false;
    } else if(cosDate.isAfter(ordDate)) {
      appContext.setDialogMessage('Costing date is after an order date.');
      return false;
    }
    return true;
  }

  const onSubmit = (data: any) => {
    if (validateForm() && validateDetails() && validateDates(data)) {
      setTimeout(() => {
      calculate();
      }, 1000);
      if('NA' === data.pack) {
        data.pack = 0;
      }
      data.detail = detailRows;
      data.inputCost = inputCost;
      data.usdRate = usdRate;
      data.eurRate = eurRate;
      data.isBale = isBale ? 1 : 0;
      data.otherCost = otherCost;
      saveCosting(data, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          if(costingData.pojo > 0) {
            appContext.setDialogMessage('The costing has a PO/JS. Input details were not updated.');
          }
          navigate(-1);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    }
  }

  const onRowSelection = (selectedRows: any) => {
    setDetailRows(selectedRows);
  }

  const onRowDelete = (selectedRows: any) => {
    setDetailRows(selectedRows);
    calculateDelete(selectedRows);
  }

  const processRowUpdate = (updatedRow: any) => {
    calculate();
  }

  function checkOutputSplit() {
    for(let i = 0; i < detailRows.length; ++i) {
      if('NA' === detailRows[i].outputSplit) {
        continue;
      } else if (isEmpty(detailRows[i].outputSplit)){
        return false;
      } else {
        let value = detailRows[i].outputSplit.split(',');
        let splitVal = 0;
        for(let j = 0; j < value.length; ++j) {
          if(isEmpty(value[j].split('=')[1]) || value[j].split('=')[1] <= 0) {
            return false;
          }
          splitVal += +value[j].split('=')[1];
        }
        
        if(100 !== splitVal) {
          return false;
        }
      }
    }
    
    return true;
  }

  function validateDependencies() {
    let values: any = [];
    for(let i = 0; i < detailRows.length; ++i) {
      let array: any = detailRows[i].dependency;

      if(array === undefined || array === null || array.length === 0 || array[0] === '') {
        //appContext.setDialogMessage('Incorrect dependencies specified.');
        return false;
      }

      for(let j = 0; isNotEmptyArray(array) && j < array.length; ++j) {
        if('NA' !== array[j]) {
          if(isEmpty(values[+array[j] - 1])) {
            values[+array[j] - 1] = 0;
          }
          ++values[+array[j] - 1];
        }
      }
    }

    for(let i = 0; i < values.length; ++i) {
      if(values[i] > 1) {
        //appContext.setDialogMessage('Incorrect dependencies specified.');
        //return false;
      }
    }

    return true;
  }

  function isFabric() {
    return 'Garment Fabric' === costingData.product || 'Home Furnishing Fabric' === costingData.product;
  }

  const calculate = () => {
    if (validateDependencies() && checkOutputSplit()) {
      let totalInputCost = 0;
      for(let i = 0;  i < detailRows.length; ++i) {
        if (!isEmpty(detailRows[i].consumptionCost)) {
          totalInputCost = totalInputCost + detailRows[i].consumptionCost;
        }
      }
      setInputCost(parseFloat((('NA' === costingData.pack ? 1 : costingData.pack) * totalInputCost).toFixed(2)));
    }
  }

  const calculateDelete = (rows: any) => {
    if (validateDependencies() && checkOutputSplit()) {
      let totalInputCost = 0;
      if (isNotEmptyArray(rows)) {
        for(let i = 0; i < rows.length; ++i) {
          if (isNotEmpty(rows[i].consumptionCost)) {
            totalInputCost = totalInputCost + +rows[i].consumptionCost;
          }
        }
      }
      setInputCost(parseFloat((('NA' === costingData.pack ? 1 : costingData.pack) * totalInputCost).toFixed(2)));
    }
  }

  const onCalculate = () => {
    if (validateForm()) {
      calculate();
    }
  }

  const onUpdateRate = () => {
    if(isNotNull(rowId)) {
      if(rateText === 'Latest') {
        setRateText('Costing');
        setUSDRate(costingData.usdRate);
        setEURRate(costingData.eurRate);
      } else {
        setRateText('Latest');
        setUSDRate(rates.usdRate);
        setEURRate(rates.eurRate);
      }
    }
  }

  const closeOthCostPopup = () => {
    //setOpenOthCost(false);
  }

  const cancelOthCost = (data: any) => {
    setOtherCost(data);
    setOpenOthCost(false);
  }

  const saveOthCost = (data: any) => {
    setOtherCost(data);
    let othCostValue = 0;
    for(let i =0; i < data.length; ++i) {
      othCostValue += data[i].unitCost * data[i].unit;
    }
    costingData.otherCostVal = othCostValue;
    calculate();
    setOpenOthCost(false);
  }

  const openOthCostPopup = (row: any) => {
    let inputCodes:any = [];
    for(let i = 0; i < detailRows.length; ++i) {
      inputCodes[i] = detailRows[i].code;
    }
    setInputCodeList(['NA', ...inputCodes.sort()]);
    setOpenOthCost(true);
  }

  function getDetails() {
    let conti = price * contingency/100;
    let finance = price * financeCost/100;
    let comm = price * commission/100;
    let othCost = ('NA' === costingData.pack ? 1 : costingData.pack) * +costingData.otherCostVal;
    let grossProfit = price * (1 - (+contingency + +financeCost + +commission)/100) - +inputCost - +othCost;

    let text = price + ',' + conti.toFixed(2) + ',' + finance.toFixed(2) + ',' + comm.toFixed(2) + ',' + 
               inputCost.toFixed(2) + ',' + othCost.toFixed(2) + ',' + grossProfit.toFixed(2);
    let array: any = text.split(',');

    array[0] = 'Price: ' + array[0];
    array[1] = 'Contingency: ' + -1 * array[1];
    array[2] = 'Finance Cost: ' + -1 * array[2];
    array[3] = 'Commission: ' + -1 * array[3];
    array[4] = 'Input Cost: ' + -1 *array[4];
    array[5] = 'Other Cost: ' + -1 * array[5];
    array[6] = 'Gross Profit: ' + array[6];

    let newText = array.map((i: any, index: any) => { 
      return <p key={index} style={{ margin: '4px 0' }}>{i}</p> 
    });

    return newText;
  }

  function calculateGrossProfit() {
    let othCost = ('NA' === costingData.pack ? 1 : costingData.pack) * +costingData.otherCostVal;
    return price * (1 - (+contingency + +financeCost + +commission)/100) - +inputCost - +othCost;
  }

  function calculateNetProfit() {
    let othCost = ('NA' === costingData.pack ? 1 : costingData.pack) * +costingData.otherCostVal;
    return price * (1 - (+contingency + +financeCost + +commission + +overhead)/100) - +inputCost - +othCost;
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={2}>
        <ITextField name='code' label='Costing Code' required={false} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='enquiryCode' label='Enquiry Code' required={true} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='customer' label='Customer' required={true} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='product' label='Product' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <IDropdown name='type' label='Type' itemList={COSTING_TYPE_SELECT_ITEMS} required={true}
         onChangeEvent={(e: any) => (setCostingType(e.target.value))} />
      </Grid>
      <Grid xs={2}>
        <IDateField name='costingDate' label='Costing Date' />
      </Grid>
      <Grid xs={2}>
        <IDropdown name='owner' label='Cost Owner' itemList={COST_OWNER_SELECT_ITEMS} required={true} />
      </Grid>
      <Grid xs={2}>
        <INumberField name='moq' label='Quantity' required={true} />
      </Grid>
      <Grid xs={1}>
        <IDropdown name='uom' label='UOM' itemList={UOM_SELECT_ITEMS.sort()} required={true} disabled={true}/>
      </Grid>
      <Grid xs={1}>
        <ITextField name='pack' label='Pc/Pack' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <INumberField name='contingencyPercentage' label='Contingency (%)' required={true}
          onActionEvent={(e: any) => { setContingency(e.target.value) }} />
      </Grid>
      <Grid xs={2}>
        <INumberField name='financeCost' label='Finance Cost (%)' required={true}
          onActionEvent={(e: any) => { setFinanceCost(e.target.value) }} />
      </Grid>
      <Grid xs={1}>
        <INumberField name='commissionPercentage' label='Comm (%)' required={true} 
          onActionEvent={(e: any) => { setCommission(e.target.value) }} />
      </Grid>
      <Grid xs={1}>
        <IButton label={'₹ ' + formatTo2Decimal(costingData.otherCostVal)} variant={'contained'} size='medium' color='secondary' 
          onActionEvent={openOthCostPopup}/>
      </Grid>
      <Grid xs={2}>
        <INumberField name='totalCost' label='Price/Pack (Incl Comm)' required={true} 
          onActionEvent={(e: any) => { setPrice(e.target.value) }}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='remarks' label='Remarks' />
      </Grid>
      <Grid xs={2}>
        <ITextField name='sampleLeadTime' label='Sampling Lead Time' />
      </Grid>
      <Grid xs={2}>
        <ITextField name='productionLeadTime' label='Production Lead Time' />
      </Grid>
      <Grid xs={2}>
        <ITextField name='packingDetails' label='Packing Details' />
      </Grid>
      {!isFabric() && <Grid xs={2}>
        <ICheckbox name='balePacking' label='Bale Packing' defaultChecked={isBale}
          onChangeEvent={(e: any) => { setIsBale(e.target.checked) }}/>
      </Grid>}
      {!isFabric() && !isBale &&
      <Grid xs={2}>
        <INumberField name='length' label='Carton Length (Inch)' required={true}
          onActionEvent={(e: any) => { setLength(e.target.value) }} />
      </Grid>}
      {!isFabric() && !isBale &&
      <Grid xs={2}>
        <INumberField name='breadth' label='Carton Breadth (Inch)' required={true} 
          onActionEvent={(e: any) => { setBreadth(e.target.value) }} />
      </Grid>}
      {!isFabric() && !isBale &&
      <Grid xs={2}>
        <INumberField name='height' label='Carton Height (Inch)' required={true} 
          onActionEvent={(e: any) => { setHeight(e.target.value) }} />
      </Grid>}
      {!isFabric() && !isBale &&
      <Grid xs={2}>
        <TextField name='cbm' label='Carton Volume/Piece (Cu Mtr)' required={true} disabled={true} value={cbm} 
          margin='dense' inputProps={{ style: { height: "9px"}}}/>
      </Grid>}
      {!isFabric() && !isBale &&
      <Grid xs={2}>
        <INumberField name='qtyPerCarton' label='Pack/Carton' required={true} 
          onActionEvent={(e: any) => { setQtyPerCarton(e.target.value) }}/>
      </Grid>}
      {isFabric() &&
      <Grid xs={2}>
        <INumberField name='gsm' label='GSM' required={true} disabled={true}/>
      </Grid>}
      {isFabric() &&
      <Grid xs={2}>
        <INumberField name='width' label='Width (Inch)' required={true} disabled={true} />
      </Grid>}
      {isFabric() &&
      <Grid xs={2}>
        <ITextField name='weight' label='Weight (Kg)' required={true} disabled={true} />
      </Grid>}
      <Grid xs={12}>
        <CostingDetailComponent onRowSelection={onRowSelection} onRowDelete={onRowDelete} product={costingData.product}
          processRowUpdate={processRowUpdate} costingType={costingType} costingData={costingData.detail} apiRef={apiRef} />
      </Grid>
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1200px', border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatToNumber(inputCost)} label={'Input Cost/Pack'} 
              onIconClick={() => onCalculate()} icon={CalculateIcon} iconTitle='Calculate Cost'/>
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatToNumber(price * 1) + ' ($ ' + formatTo2Decimal(totalUSD) +
                                  ' | € ' + formatTo2Decimal(totalEUR) + ')'} label={'Price/Pack'} />
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatToNumber(calculateGrossProfit()) + ' (' + 
                                  formatTo1Decimal(calculateGrossProfit() * 100/price) + '%/Price)'} label={'Gross Profit'} 
                                  icon={InfoIcon} iconTitle={getDetails()}/>
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatToNumber(price * overhead/100) + 
                                  ' (' + formatTo1Decimal(overhead) + '%/Price)'} label={'Overhead'} />
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatToNumber(calculateNetProfit()) + ' (' +
                                  formatTo1Decimal(calculateNetProfit() * 100/price) + '%/Price)'} label={'Net Profit'} />
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'$(' + usdRate.toFixed(2) + ') | €(' + eurRate.toFixed(2) + ')'} label={rateText} 
              onIconClick={() => onUpdateRate()} icon={ChangeCircleIcon} iconTitle='Flip Currency Rate'/>
          </Grid>
        </Grid>
      </Grid>
      <IDialogComponent onClose={closeOthCostPopup} open={openOthCost} title='Specify Cost (Per Piece)'
        dialogBody={<OtherCostComponent inputCodeList={inputCodeList} data={otherCost} submit={saveOthCost} cancel={cancelOthCost}/>} />
    </Grid>
  }

  return loader ? <></> : <IForm formData={costingData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default CostingForm;
